// On-screen keyboard. Avoids the phone keyboard pushing the game around.

import { h } from '@kit/dom';

export interface Keyboard { el: HTMLElement; setEnabled(on: boolean): void }

export function makeKeyboard(opts: { onKey(k: string): void; onBackspace?(): void; onEnter?(): void; enterLabel?: string; letters?: string }): Keyboard {
  const rows = opts.letters ? [opts.letters] : ['qwertyuiop', 'asdfghjkl', 'zxcvbnm'];
  const el = h('div.stack', { style: { gap: '4px' } });
  const buttons: HTMLButtonElement[] = [];
  rows.forEach((row, ri) => {
    const r = h('div.keys', { style: { gridTemplateColumns: `repeat(${Math.max(row.length, 10)}, 1fr)` } });
    if (ri === 1 && !opts.letters) r.style.padding = '0 5%';
    for (const ch of row) {
      const b = h('button.key', { onclick: () => opts.onKey(ch) }, ch) as HTMLButtonElement;
      buttons.push(b); r.append(b);
    }
    if (ri === rows.length - 1) {
      if (opts.onBackspace) { const b = h('button.key', { onclick: () => opts.onBackspace!(), 'aria-label': 'Backspace' }, '⌫') as HTMLButtonElement; buttons.push(b); r.append(b); }
      if (opts.onEnter) { const b = h('button.key.wide', { onclick: () => opts.onEnter!() }, opts.enterLabel || 'Go') as HTMLButtonElement; buttons.push(b); r.append(b); }
    }
    el.append(r);
  });
  return { el, setEnabled(on) { for (const b of buttons) b.disabled = !on; } };
}

/** Levenshtein distance for forgiving spelling checks */
export function editDistance(a: string, b: string): number {
  const m = a.length, n = b.length;
  const d: number[] = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i++) {
    let prev = d[0]; d[0] = i;
    for (let j = 1; j <= n; j++) {
      const tmp = d[j];
      d[j] = Math.min(d[j] + 1, d[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = tmp;
    }
  }
  return d[n];
}
